// frontend/shared-ui/src/forms/fields/ColorField.jsx
import React from "react";

export default function ColorField({ field, value, onChange }) {
  const inputId = `field-${field.key}`;
  return (
    <div className="fh-form-field">
      <label
        htmlFor={inputId}
        className={`fh-form-field__label ${field.required ? "is-required" : ""}`}
      >
        {field.label}
      </label>
      <div className="fh-color-picker-row">
        <input
          id={inputId}
          type="color"
          className="fh-color-picker"
          value={value || "#000000"}
          onChange={(e) => onChange(e.target.value)}
          disabled={field.disabled}
        />
        <input
          type="text"
          className="fh-input fh-color-picker-text"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
          disabled={field.disabled}
        />
      </div>
      {field.hint && <div className="fh-form-field__hint">{field.hint}</div>}
    </div>
  );
}
